"use client";

import { useState } from "react";
import EmailLogin from "./_components/EmailLogin";
import OTPFlow from "./_components/OTPFlow";
import LoginLayout from "./_components/LoginLayout";

export default function LoginPage() {
  const [loginType, setLoginType] = useState<"email" | "otp">("email");

  const switchToOTP = () => setLoginType("otp");
  const switchToEmail = () => setLoginType("email");

  return (
    <LoginLayout>
      {loginType === "email" ? (
        <EmailLogin onSwitchToOTP={switchToOTP} />
      ) : (
        <OTPFlow onSwitchToEmail={switchToEmail} />
      )}
    </LoginLayout>
  );
}
